module.exports = __webpack_public_path__ + "dbc80a3a0a1446e443a39ece29b10046.pdf";